import { Component, Input, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, Observable, take } from 'rxjs';
import { LoadCompanyLogo } from 'src/app/store/actions/document.action';
import { ReloadOffice } from 'src/app/store/actions/office.actions';
import { companyLogoById, DocumentUrlWithKey } from 'src/app/store/reducer/document.reducer';
import { officeById } from 'src/app/store/reducer/office.reducer';

@Component({
    standalone: false,
    selector: 'app-office-avatar',
    templateUrl: './office-avatar.component.html',
    styleUrls: ['./office-avatar.component.scss']
})
export class OfficeAvatarComponent implements OnInit {
    logo$: Observable<DocumentUrlWithKey>;
    initials$: Observable<string>;

    @Input() companyId: string;

    @Input() officeId: string;

    @Input() avatarClasses = 'w-11';

    constructor(private store: Store) {}

    ngOnInit(): void {
        if (this.companyId) {
            setTimeout(() => {
                this.store
                    .select(companyLogoById(this.companyId))
                    .pipe(take(1))
                    .subscribe((logo) => {
                        if (!logo) {
                            this.store.dispatch(LoadCompanyLogo({ companyId: this.companyId }));
                        }
                    });
            }, 0);

            this.logo$ = this.store.select(companyLogoById(this.companyId));
        }

        if (this.officeId) {
            this.store
                .select(officeById(this.officeId))
                .pipe(take(1))
                .subscribe((employee) => {
                    if (!employee) {
                        this.store.dispatch(ReloadOffice({ officeId: this.officeId }));
                    }
                });

            this.initials$ = this.store.select(officeById(this.officeId)).pipe(
                map((office) =>
                    office?.name
                        .split(' ')
                        .map((split) => split[0])
                        .join('')
                )
            );
        }
    }
}
